import { useMutation } from 'react-query';
import { exportLeadsToNeoSana } from '../api/leads';

const useExportLeads = () => useMutation({ mutationFn: ({ data }) => exportLeadsToNeoSana(data) });

export default useExportLeads;
